function getMicrochipIssuer(microchip: string): string | null {
  if (!microchip) return null;

  // NOTE: Order matters. Patterns are checked top to bottom, so more specific patterns (like Banfield's `98101000`)
  // should come before more general ones (like PetLink's `981`).

  // Banfield - 98101000 followed by 7 digits
  if (/^(98101000)[0-9]{7}$/.test(microchip)) {
    return 'Banfield';
  }

  // PetLink - 981 followed by 12 digits OR 981 followed by 20 digits
  if (/^(981)[0-9]{12}$/.test(microchip) || /^(981)[0-9]{20}$/.test(microchip)) {
    return 'PetLink';
  }

  // HomeAgain - 985 followed by 12 digits OR starts with 4 followed by 9 alphanumeric OR FDX-A followed by 5 alphanumeric
  if (
    /^(985)[0-9]{12}$/.test(microchip) ||
    /^(4)[a-zA-Z0-9]{9}$/.test(microchip) ||
    /^(FDX-A)[a-zA-Z0-9]{5}$/.test(microchip)
  ) {
    return 'HomeAgain';
  }

  // 24PetWatch - 982 followed by 12 digits OR FDX-A followed by 10 alphanumeric OR 0A1 followed by 7 alphanumeric
  if (
    /^(982)[0-9]{12}$/.test(microchip) ||
    /^(FDX-A)[a-zA-Z0-9]{10}$/.test(microchip) ||
    /^(0A1)[a-zA-Z0-9]{7}$/.test(microchip)
  ) {
    return '24PetWatch';
  }

  // AKC Reunite - 956 followed by 12 digits OR TVN followed by 12 alphanumeric OR TR followed by 13 alphanumeric OR 00 followed by 8 alphanumeric
  if (
    /^(956)[0-9]{12}$/.test(microchip) ||
    /^(TVN)[a-zA-Z0-9]{12}$/.test(microchip) ||
    /^(TR)[a-zA-Z0-9]{13}$/.test(microchip) ||
    /^(00)[a-zA-Z0-9]{8}$/.test(microchip)
  ) {
    return 'AKC Reunite';
  }

  // Banfield - 0D0D followed by 6 alphanumeric (duplicate case from above, but keeping for completeness)
  if (/^(0D0D)[a-zA-Z0-9]{6}$/.test(microchip)) {
    return 'Banfield';
  }

  // Save This Life - 900164 followed by 9 digits
  if (/^(900164)[0-9]{9}$/.test(microchip)) {
    return 'Save This Life';
  }

  // BuddyID - 933 followed by 12, 9, or 20 alphanumeric characters
  if (
    /^(933)[a-zA-Z0-9]{12}$/.test(microchip) ||
    /^(933)[a-zA-Z0-9]{9}$/.test(microchip) ||
    /^(933)[a-zA-Z0-9]{20}$/.test(microchip)
  ) {
    return 'BuddyID';
  }

  // AVID - 10 alphanumeric characters OR 977 followed by 12 digits OR format XXX*XXX*XXX (3 digits, asterisk, 3 digits, asterisk, 3 digits)
  if (
    /^[a-zA-Z0-9]{10}$/.test(microchip) ||
    /^(977)[0-9]{12}$/.test(microchip) ||
    /[0-9]{3}[*][0-9]{3}[*][0-9]{3}$/.test(microchip)
  ) {
    return 'AVID';
  }

  return null;
}

export { getMicrochipIssuer };
